import { useNavigate } from "react-router-dom";
import { relativeURL } from "../relativeURL";

export const useImportSession = () => {
  let navigate = useNavigate();
  async function importSession(exportedSession) {
    const resp = await fetch(relativeURL("/api/import"), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(exportedSession),
    });

    const body = await resp.json();
    navigate(`/session/${body.sid}`);
  }

  return {
    importSession,
  };
};
